import React from "react";
import FieldWrapper from "../Common/FieldWrapper";
import Switch from "react-switch";
import { themeColor } from "../../../utils/shared";
import Icon from "../../Common/Icon";

export default class SwitchField extends FieldWrapper {
  constructor() {
    super();
    this.state = { disabled: false };
  }
  handleChange = (checked) => {
    this.props.formikForm.setFieldValue(this.props.config.name, checked);
  };

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    const {
      formikForm,
      config: { name, requires },
    } = this.props;
    const disabled = !!(requires && !formikForm.values[requires]);
    if (disabled !== this.state.disabled) {
      this.setState({ disabled: disabled });
      if (disabled) {
        formikForm.setFieldValue(name, false);
      }
    }
  }

  renderField() {
    const {
      formikField,
      config: { name, label, show },
    } = this.props;

    return (
      <div
        className={`field__group ${
          show !== null && show === "False" ? "field_hidden" : ""
        }`}
      >
        <label className="container--flex" htmlFor={name}>
          <span>{label}</span>
          <Switch
            id={name}
            checked={formikField.value}
            disabled={this.state.disabled}
            {...formikField}
            onChange={this.handleChange}
            uncheckedIcon={false}
            checkedIcon={false}
            checkedHandleIcon={
              <Icon iconName="checkmark" className="icon--checkmark-switch" />
            }
            height={29}
            handleDiameter={25}
            width={49}
            onColor={themeColor}
            activeBoxShadow={"0"}
          />
        </label>
        <hr className="hr hr-switch" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/SwitchField.js